import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { medioPagoPropType } from '../../ui/widgets/index.js'
import {
  calcularTotalItemConIva,
  calcularTotalItemSinIva,
  esMayorista,
  valorUnitarioSinIva
} from '../helpers/calcularPrecioTotal'
import { DetallePrecio } from './DetallePrecio'
import styles from './Vendedor.module.css'

const Vendedor = ({ vendedor }) => {
  const navigate = useNavigate()

  const total = vendedor.pedidoItems.reduce(
    (total, item) => total + calcularTotalItemConIva(item),
    0
  )

  const totalSinIva = vendedor.pedidoItems.reduce(
    (total, item) => total + calcularTotalItemSinIva(item),
    0
  )

  const detallePrecioProps = {
    pedidoItems: vendedor.pedidoItems,
    valorUnitarioSinIva,
    esMayorista,
    total,
    totalSinIva,
    porcDcto: vendedor.pedidoItems[0]?.porcDcto || 0
  }

  return (
    <div className={styles.page} key={vendedor.idVendedor}>
      <div className={styles.row}>
        <div className={styles.header}>
          <h1 className={styles.title}>
            Vendedor: {vendedor.razonSocial || vendedor.pedidoItems[0].nombre}
          </h1>
          <p className={styles.subtitle}>Revisá el detalle antes de continuar con la compra</p>
        </div>

        <div className={styles.summaryCard}>
          <DetallePrecio {...detallePrecioProps} usaImagen={true} />
        </div>

        <div className={styles.continueButton}>
          <button
            type="button"
            className="btn-primary btnAccionCompra"
            id="checkout-btn"
            onClick={() => navigate('/Compra', { state: { vendedor } })}
          >
            Continuar compra
          </button>
        </div>
      </div>
    </div>
  )
}

Vendedor.propTypes = {
  vendedor: PropTypes.shape({
    idVendedor: PropTypes.number.isRequired,
    empidVendedor: PropTypes.string,
    razonSocial: PropTypes.string,
    pedidoItems: PropTypes.arrayOf(
      PropTypes.shape({
        idPublicacion: PropTypes.number.isRequired,
        titulo: PropTypes.string,
        nombre: PropTypes.string,
        cantidad: PropTypes.number,
        cantidadMayorista: PropTypes.number,
        precioUnitario: PropTypes.number,
        precioUnitarioMayorista: PropTypes.number,
        alicuota: PropTypes.number,
        monedaSimbolo: PropTypes.string,
        porcDcto: PropTypes.number,
        empid: PropTypes.string,
        anticipo: PropTypes.number,
        total: PropTypes.number,
        tipoUsuario: PropTypes.string,
        // node los devuelve resueltos; los presupuestos (.NET) como ids en texto
        mediosPagos: PropTypes.arrayOf(
          PropTypes.oneOfType([PropTypes.string, PropTypes.number, medioPagoPropType])
        )
      })
    ).isRequired,
    idUsuario: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired
}
export default Vendedor
